import {
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes,
  animation
} from '@angular/animations';

export const slideAnimation = animation([
    style({ opacity: 0 }),
    animate('1s 0.7s', keyframes([
        style({ opacity: 0, transform: 'translate3d(0, {{ from }}, 0)' }),
        style({ opacity: 1, transform: 'translate3d(0, {{ to }}, 0)' })
    ]))
], {
    delay: '1s',
    params: {
        from: '100%',
        to: '0'
    }
});



// WEBPACK FOOTER //
// ./src/app/shared/animations/slide.animation.ts